import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/lib/auth';
import { AppLayout, PublicLayout } from '@/components/layout/AppLayout';
import { GuestRoute, ProtectedRoute } from '@/components/layout/ProtectedRoute';
import { HomePage } from '@/pages/HomePage';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { EventsPage } from '@/pages/EventsPage';
import { EventDetailPage } from '@/pages/EventDetailPage';
import { EventEditPage } from '@/pages/EventEditPage';
import { OrganizationEditPage } from '@/pages/OrganizationEditPage';
import { JoinPage } from '@/pages/JoinPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { TasksPage } from '@/pages/TasksPage';
import { ChecklistsPage } from '@/pages/ChecklistsPage';
import { ExpensesPage } from '@/pages/ExpensesPage';
import { MembersPage } from '@/pages/MembersPage';
import { ChatPage } from '@/pages/ChatPage';
import { BarlaPage } from '@/pages/BarlaPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

/* Her sayfa önce kuruluş listesini istiyor, kimliği eline geçince asıl
   verisini: iki istek arka arkaya, ekranda bir şey görünmeden. Liste
   otuz saniyede eskidiği için biraz oyalanan kullanıcı her geçişte bu
   beklemeyi baştan ödüyordu.
   Kuruluş listesi neredeyse hiç değişmiyor; bir saat taze sayılıyor.
   Yeni kuruluş açıldığında o sayfa zaten refetch çağırıyor, orada
   tazeliğe bakılmıyor. */
queryClient.setQueryDefaults(['organizations'], {
  staleTime: 60 * 60 * 1000,
  gcTime: 24 * 60 * 60 * 1000,
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter basename="/">
          <Routes>
            <Route element={<PublicLayout />}>
              <Route index element={<HomePage />} />
              <Route element={<GuestRoute />}>
                <Route path="login" element={<LoginPage />} />
              </Route>
              <Route path="join/:code" element={<JoinPage />} />
              {/* Gezi rehberi: girişsiz de okunabilsin, paylaşılabilsin. */}
              <Route path="barla" element={<BarlaPage />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="org/:orgId/edit" element={<OrganizationEditPage />} />
                <Route path="events" element={<EventsPage />} />
                <Route path="event/:eventId/edit" element={<EventEditPage />} />
                <Route path="event/:eventRef" element={<EventDetailPage />} />
                <Route path="tasks" element={<TasksPage />} />
                <Route path="checklists" element={<ChecklistsPage />} />
                <Route path="members" element={<MembersPage />} />
                <Route path="expenses" element={<ExpensesPage />} />
                <Route path="chat" element={<ChatPage />} />
                <Route path="profile" element={<ProfilePage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
